import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class FollowUpStatusMasterService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    private baseUrl = 'api/followUpStatusMaster';

    constructor(private http: Http) {}

    private extractData(res: any) {
        return res.json() || [];
    }

    getTeamList(): Promise<any> {
        const options = new RequestOptions({ headers: this.headers });
        return this.http.get(`${this.baseUrl}/getTeamList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    getStatusList(column: string): Promise<any> {
        const params = new URLSearchParams();
        params.set('column', column);
        const options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getStatusList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    save(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/save`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json()).catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/followUpStatusMaster.service.ts